import i18n from 'i18n/config';
import { useEffect, useState } from 'react';
import { SelectorOption } from 'types';

import operationTypes from 'constants/operationTypes';
import priceTypes from '../constants/priceTypes';

type UseGetPriceOptionsProps = {
  operationType: string;
};

const getOptions = (operationType: string): SelectorOption[] => {
  let fixedPriceLabel = '';

  switch (operationType) {
    case operationTypes.SELL_PARTICIPATION:
      fixedPriceLabel = 'TotalPriceForSale';
      break;
    case operationTypes.HERITAGE:
      fixedPriceLabel = 'TotalHeritagePrice';
      break;
    case operationTypes.DONATION:
      fixedPriceLabel = 'TotalDonationPrice';
      break;
    case operationTypes.ENDORSEMENT:
      fixedPriceLabel = 'TotalEndorsementPrice';
      break;
    default:
      break;
  }

  const options = priceTypes.map((price) => ({
    value: price.value,
    label: i18n.t(price.label),
  }));

  options[0].label = i18n.t(fixedPriceLabel);
  return options;
};

export const useGetPriceTypeOptions = ({
  operationType,
}: UseGetPriceOptionsProps) => {
  const [priceTypeOptions, setPriceTypeOptions] = useState<SelectorOption[]>(
    []
  );
  const [selectedPriceTypeOption, setSelectedPriceTypeOption] =
    useState<SelectorOption | null>(null);

  const [selectedPriceType, setSelectedPriceType] = useState<string>(
    priceTypes[1].value
  );

  const handleChangePriceTypeOption = (selectedOption: SelectorOption) => {
    setSelectedPriceType(selectedOption?.value || '');
    setSelectedPriceTypeOption(selectedOption);
  };

  useEffect(() => {
    const options = getOptions(operationType);
    setSelectedPriceTypeOption(options[1]);
    setPriceTypeOptions(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operationType, i18n.language]);

  return {
    data: {
      selectedPriceType,
      selectedPriceTypeOption,
      priceTypeOptions,
    },

    actions: {
      handleChangePriceTypeOption,
    },
  };
};
